import { axios } from '@Api/axiosClient';
import type { IdentityProfile } from '@Types/IdentityProfile.interface';

const baseUrl: string = '/api/kyc';

export const verifyIdentityApi = async (profile: IdentityProfile): Promise<null> => {
    await axios.post(`${baseUrl}/VerifyIdentity`, profile);
};

export interface KycUserProfile {
    firstName?: string;
    lastName?: string;
    email?: string;
    dateOfBirth?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    zip?: string;
}

export const getKycUserProfileApi = async (): Promise<KycUserProfile | null> => {
    try {
        const response = await axios.get<KycUserProfile>(`${baseUrl}/UserProfile`);
        return response.data ?? null;
    } catch (err) {
        console.warn('[Auth MFE] Failed to fetch KYC user profile — pre-fill skipped:', err);
        return null;
    }
};